import {PartOfTheDay} from './PartOfTheDay';

export type CompleteUntil = {
  time?: string | undefined | null;
  partOfTheDay?: PartOfTheDay | undefined | null;
};

export enum DurationType {
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
}

export type Duration = {
  type: DurationType;
  amount: number;
};
